import React from 'react';
import { Button, Icon, Header, Grid } from "semantic-ui-react";
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { ITEMS_PER_PAGE } from '../utils/pagination'

class PaginationWrapper extends React.Component {
  handlePrevious(){
    this.replaceLocation({
      before: this.props.startCursor,
      last: ITEMS_PER_PAGE
    })
  }

  handleNext(){
    this.replaceLocation({
      after: this.props.endCursor,
      first: ITEMS_PER_PAGE
    })
  }
  handleJumpToStart(){
    this.replaceLocation()
  }

  handleJumpToEnd(){
    this.replaceLocation({
      last: ITEMS_PER_PAGE,
    })
  }

  replaceLocation(newPagination={}){
    const currentQueryHash = queryString.parse(this.props.history.location.search, {arrayFormat: 'bracket'})
    const newQueryHash = Object.assign(currentQueryHash, {
       before: undefined,
       last: undefined,
       after: undefined,
       first: undefined
    },newPagination)
    let query = queryString.stringify(newQueryHash, {arrayFormat: 'bracket'})
    query = query.replace(/%5B%5D/g, '')
    this.props.history.replace({...this.props.history.location, search: query})

    window.scrollTo(0,0);
  }

  render() {
    const {
      hasPreviousPage,
      hasNextPage,
      totalCount,
      history
    } = this.props;
    let nextButtonDiabled = false;
    const currentQueryHashKeys = Object.keys(queryString.parse(history.location.search));
    if(currentQueryHashKeys.includes('last') && !currentQueryHashKeys.includes('before')){
      nextButtonDiabled = true;
    }
    return (
      <Grid padded>
        <Grid.Row>
          <Grid.Column width={9}>
            <Button icon onClick={this.handleJumpToStart.bind(this)}>
              <Icon name='step backward' />
            </Button>
            <Button content='Previous' icon='left arrow' labelPosition='left' disabled={!hasPreviousPage} onClick={this.handlePrevious.bind(this)} />
            <Button content='Next' icon='right arrow' labelPosition='right' disabled={!hasNextPage || nextButtonDiabled} onClick={this.handleNext.bind(this)} />
            <Button icon onClick={this.handleJumpToEnd.bind(this)} disabled={!hasNextPage}>
              <Icon name='step forward' />
            </Button>
          </Grid.Column>
          <Grid.Column width={7} textAlign='right'>
            {totalCount ? <Header size='tiny'>Items matching current filter: {totalCount}</Header> : null}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

export default withRouter(PaginationWrapper);



// WEBPACK FOOTER //
// ./src/component/PaginationWrapper.js